import { Hero } from '@/components/Hero/Hero';
import { ProductGrid } from '@/components/layout/ProductList';

export const HomePage = () => {
    return (
        <div className="">
            <Hero />
            <ProductGrid />
        </div>
    );
};
